export const SwooshLeftBlue = () => {
    return (
        <svg
            width="666"
            height="165"
            viewBox="0 0 666 165"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                opacity="0.3"
                d="M-137.001 9.00044C-75.5304 60.3756 33.9996 153.222 258.126 153.221C443.499 153.221 537 134.5 659 52"
                stroke="url(#swoosh-left-blue-gradient)"
                strokeWidth="23"
            />
            <defs>
                <linearGradient
                    id="swoosh-left-blue-gradient"
                    x1="-18.9408"
                    y1="125.238"
                    x2="855.507"
                    y2="28.6035"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#79E2F2" />
                    <stop
                        offset="0.546875"
                        stopColor="#79E2F2"
                        stopOpacity="0"
                    />
                    <stop
                        offset="0.734375"
                        stopColor="#79E2F2"
                        stopOpacity="0"
                    />
                    <stop offset="1" stopColor="#79E2F2" />
                </linearGradient>
            </defs>
        </svg>
    );
};
